import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { useDemoMode } from '@/demo/DemoContext';

/**
 * Safe back navigation — falls back to home if there's no history to go back to
 * (e.g. user navigated directly via URL or refreshed the page).
 *
 * The fallback is prefix-aware: in demo mode a cold load straight to
 * `/demo/debt` has no history to pop, and a bare `/` would drop the visitor
 * out of the demo session into the real (signed-out) app. Outside demo mode
 * `routePrefix` is '' and the target is plain '/', exactly as before.
 */
export function useNavigateBack() {
  const navigate = useNavigate();
  const { routePrefix } = useDemoMode();

  return useCallback(() => {
    if (window.history.state?.idx > 0) {
      navigate(-1);
    } else {
      navigate(`${routePrefix}/`);
    }
  }, [navigate, routePrefix]);
}
